import { render, staticRenderFns } from "./table-draggable.vue?vue&type=template&id=5a65e485&scoped=true"
import script from "./table-draggable.vue?vue&type=script&lang=js"
export * from "./table-draggable.vue?vue&type=script&lang=js"
import style0 from "./table-draggable.vue?vue&type=style&index=0&id=5a65e485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65e485",
  null
  
)

export default component.exports